import { render, staticRenderFns } from "./ContractDetailTable.vue?vue&type=template&id=8a55cf7a&scoped=true"
import script from "./ContractDetailTable.vue?vue&type=script&lang=js"
export * from "./ContractDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a55cf7a",
  null
  
)

export default component.exports